// extracted by mini-css-extract-plugin
export var bottomRightDock = "_23-0";